export const DASHBOARD_ONBOARDING_TARGETS = {
  learning: "learning-suraasa-plus-new-year-joyride",
  masterclasses: "masterclasses-suraasa-plus-new-year-joyride",
  aiTools: "ai-tools-suraasa-plus-new-year-joyride",
  cpatAssessment: "cpat-assessment-suraasa-plus-new-year-joyride",
  jobs: "jobs-suraasa-plus-new-year-joyride",
}
